import Model from '@/models/Model';

export default class UsedProduct extends Model {
    get route () {
        return 'used-products';
    }

    static get className () {
        return 'UsedProduct';
    }
}
